export default "__VITE_ASSET__Dy3eS9tc__"